<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="Vehiculos">
        <vehicleview />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import vehicleview from "@/views/modules/vehicle_module/vehicleview.vue";
export default {
  name: "vehicleOp",
  components: {
    vehicleview
  }
};
</script>

<style></style>
